export default {
  SUBSCRIPTIONS_LIST: "Liste des inscriptions",
  ADD_SUBSCRIPTION: "Ajouter une inscription",
  SUBSCRIPTION_ADDED: "Inscription ajoutée",
  EDIT_SUBSCRIPTION: "Modifier une inscription",
  SUBSCRIPTION_UPDATED: "Inscription mise à jour",
  DELETE_THIS_SUBSCRIPTION: "Supprimer cette inscription ?",
  SUBSCRIPTION_DELETED: "Inscription supprimée",
  START_TIME: "Date de début",
  END_TIME: "Date de fin",
  ACTIVE: "Actif",
  EXPIRED: "Expiré",
  RENEW: "Renouveler",
  SUBSCRIPTION_INVOICE_ADDED: "Facture renouvellement ajoutée",
};
